module.exports = __webpack_public_path__ + "img/case-studies2.1b73e992.jpg";